"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Maintenance;
const jsx_runtime_1 = require("react/jsx-runtime");
const lottie_react_native_1 = __importDefault(require("lottie-react-native"));
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const Helper_1 = require("../Helper");
const Button_1 = __importDefault(require("../components/Button"));
const ThemeContext_1 = require("../ThemeContext");
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    return react_native_1.StyleSheet.create({
        card: {
            alignSelf: 'center',
            backgroundColor: '#f8f8f8',
            borderColor: '#e8e8e8',
            borderRadius: 150,
            borderWidth: 1,
            height: 300,
            width: 300,
            elevation: 2,
            shadowColor: Helper_1.Helper.isPlatformWeb ? '#00000022' : '#444',
            shadowOffset: { height: 2, width: 0 },
            shadowRadius: 2,
            marginTop: 12
        }
    });
};
function Maintenance(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const styles = useStyles();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const maintenanceRef = react_1.default.useRef(null);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.card, children: (0, jsx_runtime_1.jsx)(lottie_react_native_1.default, { ref: maintenanceRef, source: require('../animations/maintenance.json'), autoPlay: true, loop: true, style: [{ zIndex: 100000, height: '100%', width: '100%' }], onAnimationFinish: () => maintenanceRef.current?.resume(), resizeMode: 'cover' }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginTop: 24 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { color: THEME.AlwaysWhite, fontSize: size != 'sm' ? 22 : 18, textAlign: 'center', fontWeight: '500' }, children: t('common:messages.maintenanceTitle') }), (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { color: THEME.AlwaysWhite, fontSize: size != 'sm' ? 16 : 12, textAlign: 'center', marginTop: 16 }, children: t('common:messages.maintenanceDescription') })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', marginTop: 36 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { color: THEME.AlwaysWhite, onPress: () => {
                        Authentication_1.default.SignOut();
                    }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.Text, { style: { marginHorizontal: 12, color: THEME.PrimaryDark, fontSize: 18, fontWeight: '500' }, children: t('common:buttons.logout') }) }) })] }));
}
